












































import Vue from 'vue'
export default Vue.extend({
  name: 'CustomDialog',
  props: {
    dialogClass: String,
    title: String,
    height: String,
    width: String,
    value: Boolean,
  },
  data() {
    return {
      Title: this.title || 'Custom Picker',
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      visible: false,
    }
  },
  watch: {
    visible: function() {
      this.$emit('input', this.visible)
    },
  },
  methods: {
    show() {
      const target = this.$refs.CustomDialog as HTMLDivElement
      // target.style.left = ev.clientX + 'px'
      // target.style.top = ev.clientY + 'px'
      target.style.left = '50%'
      target.style.top = '50%'
      this.visible = true
    },
    handleMouseDown(e: MouseEvent) {
      e.preventDefault()
      // get the mouse cursor position at startup:
      this.startX = e.clientX
      this.startY = e.clientY

      document.onmouseup = function() {
        document.onmouseup = null
        document.onmousemove = null
      }
      // // call a function whenever the cursor moves:
      document.onmousemove = this.handleMouseMove
    },

    handleMouseMove(e: MouseEvent) {
      e.preventDefault()
      // calculate the new cursor position:
      this.endX = this.startX - e.clientX
      this.endY = this.startY - e.clientY
      this.startX = e.clientX
      this.startY = e.clientY

      const elmnt = this.$refs.CustomDialog as HTMLDivElement

      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - this.endY + 'px'
      elmnt.style.left = elmnt.offsetLeft - this.endX + 'px'
    },

    handleOk() {
      this.$emit('ok')
      this.visible = false
    },

    handleCancel() {
      this.$emit('cancel')
      this.visible = false
    },
  },
})
